<template lang="pug">
modal.login-modal(ref="loginModal", v-model="showLoginModal", :small="true")
  div.modal-header(slot="modal-header")
    div.logo
  div.modal-body(slot="modal-body")
    .modal-title
      h2.text-center(v-if="type === 'forgotpassword'") {{ $t('loginModal.areYouForgotPassword') }}
      h2.text-center(v-else) {{ $t('loginModal.slogan') }}
    div(v-if="type === 'login' || type === 'signup'")
      h4.title.text-center {{ $t('loginModal.youCanSignupWith') }}
      .social-login.login-wrap.row
        .col-sm-12
          a(href="/oauth/facebook", @click="ssoSignup('Facebook')").btn.btn-block.btn-lg.btn-social.btn-facebook
            i.fa.fa-facebook
            | {{ $t('loginModal.facebookLogin') }}
        .col-sm-12
          a(href="/oauth/twitter", @click="ssoSignup('Twitter')").btn.btn-block.btn-lg.btn-social.btn-twitter
            i.fa.fa-twitter
            | {{ $t('loginModal.twitterLogin') }}
        .col-sm-12
          a(href="/oauth/google", @click="ssoSignup('Google+')").btn.btn-block.btn-lg.btn-social.btn-google
            i.fa.fa-google
            | {{ $t('loginModal.googleLogin') }}
      form(v-if="type === 'login'")
        h3.text-center.or {{ $t('loginModal.or') }}
        .form-group
          label(style="margin-right:6px;") {{ $t('loginModal.account') }}
          input.form-control(type="text", v-model="loginAccount", v-bind:placeholder="$t('loginModal.accountPlaceholder')")
        .form-group
          label(style="margin-right:6px;") {{ $t('loginModal.password') }}
          input.form-control(type="password", v-model="loginPassword", v-bind:placeholder="$t('loginModal.passwordPlaceholder')")
        button.btn.btn-block.btn-pink(@click.prevent="loginButton") {{ $t('loginModal.login') }}
      form(v-if="type === 'signup'")
        h3.text-center.or {{ $t('loginModal.or') }}
        .form-group
          input.form-control(type="text", v-model="signupAccount", v-bind:placeholder="$t('loginModal.username')")
        .form-group
          input.form-control(type="text", v-model="signupEmail", v-bind:placeholder="'E-mail'")
        .form-group
          input.form-control(type="password", v-model="signupPassword", v-bind:placeholder="$t('loginModal.yourPassword')")
        .form-group
          input.form-control(type="password", v-model="repaetSignupPassword", v-bind:placeholder="$t('loginModal.repeatYourPassword')")
        button.btn.btn-block.btn-pink(@click.prevent="signupButton") {{ $t('loginModal.goSignup') }}
    form(v-if="type === 'forgotpassword'")
      h4.title.text-center {{ $t('loginModal.forgotPasswordMessage') }}
      .form-group
        input.form-control(type="text", v-model="loginAccount", placeholder="E-mail")
      button.btn.btn-block.btn-pink(@click.prevent="forgotPasswordButton") {{ $t('common.submit') }}
  div.modal-footer(slot="modal-footer")
    a.btn.btn-link.go-login(@click.prevent="type = 'login'", v-if="type === 'signup'") {{ $t('loginModal.goLogin') }}
    a.btn.btn-link(@click.prevent="type = 'signup'", v-if="type !== 'signup'") {{ $t('loginModal.goSignup') }}
    a.btn.btn-link(@click.prevent="type = 'forgotpassword'", v-if="type === 'login'") {{ $t('loginModal.forgotPassword') }}
    a.btn.btn-link(@click.prevent="type = 'login'", v-if="type === 'forgotpassword'") {{ $t('loginModal.login') }}
</template>

<script>
import { modal } from 'vue-strap'
import { mapActions, mapGetters } from 'vuex'
import gaExt from 'utilities/gaExt'
import cookies from 'utilities/cookies'

export default {
  components: {
    'modal': modal
  },
  data () {
    let locale = 'tw'
    if (typeof this.$route.params !== 'undefined' &&
      typeof this.$route.params.locale !== 'undefined') {
      locale = this.$route.params.locale
    }
    return {
      locale: locale,
      endPoint: process.env.API_END_POINT,
      loginAccount: '',
      loginPassword: '',
      signupAccount: '',
      signupEmail: '',
      signupPassword: '',
      repaetSignupPassword: '',
      type: 'login',
      showLoginModal: false
    }
  },
  mounted () {
    this.$refs.loginModal.$on('cancel', () => {
      this.dismissLoginModal()
    })
    this.showLoginModal = this.isShowLoginModal
  },
  computed: mapGetters({
    isShowLoginModal: 'utilities/isShowLoginModal'
  }),
  methods: {
    ssoSignup (type) {
      gaExt.doEventBeacon(true, {
        category: 'User Account',
        action: 'Sign up with ' + type,
        userId: null
      })
    },
    forgotPasswordButton () {
      if (this.loginAccount === '') {
        this.$swal({
          title: 'Error',
          type: 'warning',
          text: this.$t('resetPassword.fillEmail')
        })
        return false
      }
      this.forgotPassword({
        email: this.loginAccount,
        locale: this.locale
      }).then(data => {
        if (data.status === 'err') {
          this.$swal({
            title: 'Error',
            type: 'warning',
            text: this.$t('resetPassword.accountError')
          })
        } else {
          this.$swal({
            title: 'Succeeded',
            type: 'success',
            text: this.$t('resetPassword.forgotPasswordSucceeded')
          })
        }
      }, (err) => {
        if (err.code === 400) {
          this.$swal({
            title: 'Error',
            type: 'warning',
            text: this.$t('resetPassword.fillEmail')
          })
          return false
        }
        if (err.code === 404) {
          this.$swal({
            title: 'Error',
            type: 'warning',
            text: this.$t('resetPassword.cannotFindUserByEmail')
          })
          return false
        }
        this.$swal({
          title: 'Error',
          type: 'warning',
          text: this.$t('loginModal.forgotPasswordFailed')
        })
      })
    },
    signupButton () {
      if (this.signupAccount === '') {
        this.$swal({
          title: 'Error',
          type: 'warning',
          text: this.$t('resetPassword.fillAccount')
        })
        return false
      }
      if (this.signupEmail === '') {
        this.$swal({
          title: 'Error',
          type: 'warning',
          text: this.$t('resetPassword.fillEmail')
        })
        return false
      }
      if (this.signupPassword === '') {
        this.$swal({
          title: 'Error',
          type: 'warning',
          text: this.$t('resetPassword.fillPassword')
        })
        return false
      }
      if (this.signupPassword !== this.repaetSignupPassword) {
        this.$swal({
          title: 'Error',
          type: 'warning',
          text: this.$t('resetPassword.repaetPasswordNotTheSame')
        })
        return false
      }
      this.register({
        name: this.signupAccount,
        email: this.signupEmail,
        password: this.repaetSignupPassword
      }).then(data => {
        if (data.status === 'err') {
          this.$nextTick(() => {
            this.$swal({
              title: 'Error',
              type: 'warning',
              html: this.$t('loginModal.loginFailed')
            })
          })
        } else {
          gaExt.doEventBeacon(true, {
            category: 'User Account',
            action: 'Log in with email',
            userId: null
          })

          this.dismissLoginModal()

          this.$router.push({
            name: 'registerSucceeded'
          })

          // const referrerUrl = cookies.get('referrerUrl')
          // if (typeof referrerUrl === 'undefined' ||
          //   /(signin|signup|login|reset-password)/gmi.test(referrerUrl)
          // ) {
          //   this.$router.push({ path: '/' })
          // } else {
          //   window.location.href = referrerUrl
          // }
        }
      }, (err) => {
        let message = this.$t('loginModal.registerFailed')
        if (err.code === 409) {
          message = this.$t('loginModal.accountAlreadyExists')
        }
        this.$nextTick(() => {
          this.$swal({
            title: 'Error',
            type: 'warning',
            text: message
          })
        })
      })
    },
    loginButton () {
      if (this.loginAccount === '') {
        this.$swal({
          title: 'Error',
          type: 'warning',
          text: this.$t('resetPassword.fillAccount')
        })
        return false
      }
      if (this.loginPassword === '') {
        this.$swal({
          title: 'Error',
          type: 'warning',
          text: this.$t('resetPassword.fillPassword')
        })
        return false
      }
      this.login({
        email: this.loginAccount,
        password: this.loginPassword
      }).then(data => {
        if (data.status === 'err') {
          this.$nextTick(() => {
            this.$swal({
              title: 'Error',
              type: 'warning',
              html: this.$t('loginModal.loginFailed')
            })
          })
        } else {
          gaExt.doEventBeacon(true, {
            category: 'User Account',
            action: 'Log in with email',
            userId: null
          })
          this.dismissLoginModal()

          const referrerUrl = cookies.get('referrerUrl')
          if (typeof referrerUrl === 'undefined' ||
            /(signin|signup|login|reset-password)/gmi.test(referrerUrl)
          ) {
            this.$router.push({ path: '/' })
          } else {
            window.location.href = referrerUrl
          }
        }
      }, () => {
        this.$nextTick(() => {
          this.$swal({
            title: 'Error',
            type: 'warning',
            html: this.$t('loginModal.loginFailed')
          })
        })
      })
    },
    ...mapActions({
      login: 'users/login',
      register: 'users/register',
      forgotPassword: 'users/forgotPassword',
      dismissLoginModal: 'utilities/dismissLoginModal'
    })
  },
  watch: {
    isShowLoginModal (show) {
      this.showLoginModal = !!show
      if (typeof this.$route.query.login_type !== 'undefined') {
        if (['signup', 'login', 'forgotpassword'].indexOf(this.$route.query.login_type) > -1) {
          this.type = this.$route.query.login_type
        }
      }
    }
  }
}
</script>
<style lang="sass">
@import '~globalStyles/variables'
.login-modal
  .modal-body, .modal-footer
      background-color: $background
  .modal-dialog
    width: 450px
    max-width: 100%
  .modal-body
    h4
      font-size: 14px
  .social-login
    padding: 10px 30px
    a
      margin: 6px 0
      @media screen and (max-width: $breakpoint-xs)
        margin: 12px 0
  form
    padding: 0 30px
    h3.or
      color: $light-grey-1
      &::after
        display: inline-block
        content: ''
        height: 1px
        background: $light-grey-1
        width: 45%
        margin: 0 0 6px 6px
      &::before
        display: inline-block
        content: ''
        height: 1px
        background: $light-grey-1
        width: 45%
        margin: 0 6px 6px 0

  .modal-footer
    text-align: center
    .btn + .btn
      margin-left: 0
    a
      position: relative
      &:first-child:after
        content: "|"
        display: inline
        position: absolute
        right: -1px
        color: #8c806b
      &.go-login
        &:first-child:after
          display: none

</style>



// WEBPACK FOOTER //
// src/components/loginModal.vue